// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__qQq13","head":"Table_head__25oNA","col":"Table_col__3t0HW"};